import { render, staticRenderFns } from "./InvoicesActionContractSelector.vue?vue&type=template&id=04d775fd&scoped=true"
import script from "./InvoicesActionContractSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoicesActionContractSelector.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoicesActionContractSelector.vue?vue&type=style&index=0&id=04d775fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d775fd",
  null
  
)

export default component.exports